// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"Z0-z","subtitle":"_0-z","wrapper":"a1-z","leftArrow":"b1-z","rightArrow":"c1-z"};